/** @format */

export const DEFAULT_TEST_ID = 'modal';

export enum ModalSize {
    SMALL = 'small',
    MEDIUM = 'medium',
    LARGE = 'large',
    FULLSCREEN = 'fullscreen',
}

export enum ModalVariant {
    DEFAULT = 'default',
    HOLOGRAPHIC = 'holographic',
}
